// Remove keys with empty values from an object recursively
export function removeEmpty(obj: object): object {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([_, v]) => v !== null && v !== undefined)
      .map(([k, v]) => [k, v === Object(v) ? removeEmpty(v) : v]),
  );
}
